import {BookmarkIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'
import {useMemo} from 'react'

import {LABELS} from '../../constants'
import type {SavedView} from '../../types'
import {splitViewsByVisibility} from '../../utils/views-visibility'
import type {PinControls} from './PinViewMenuItem'
import styles from './RepositoryViews.module.css'
import {ViewsSection} from './ViewsSection'

type ViewsSectionsProps = {
  views: SavedView[]
  owner: string
  repo: string
  newViewUrl: string
  viewerCanManageViews?: boolean
  showPinControls?: boolean
  pinControls?: PinControls
}

export function ViewsSections({
  views,
  owner,
  repo,
  newViewUrl,
  viewerCanManageViews = false,
  showPinControls = false,
  pinControls,
}: ViewsSectionsProps) {
  const {team, personal} = useMemo(() => splitViewsByVisibility(views), [views])

  if (team.length === 0 && personal.length === 0) {
    return (
      <div className={styles.viewsListWrapper}>
        <Blankslate>
          <Blankslate.Visual>
            <BookmarkIcon size="medium" />
          </Blankslate.Visual>
          <Blankslate.Heading>{LABELS.views.emptyHeading}</Blankslate.Heading>
          <Blankslate.Description>{LABELS.views.emptyDescriptionTeamPersonal}</Blankslate.Description>
        </Blankslate>
      </div>
    )
  }

  const shared = {owner, repo, newViewUrl, viewerCanManageViews, showPinControls, pinControls}

  return (
    <div className={styles.viewsSections}>
      <ViewsSection visibility="personal" views={personal} otherSectionsHaveViews={team.length > 0} {...shared} />
      <ViewsSection visibility="team" views={team} otherSectionsHaveViews={personal.length > 0} {...shared} />
    </div>
  )
}
